module.exports = __webpack_public_path__ + "static/media/doc.7cd7bcc5.svg";